import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ModalDialog from '../common/ModalDialog';
import { t } from 'i18next';

type ReloadHandlerProps = {
    reloadPath: string;
};

const ReloadHandler = ({ reloadPath }: ReloadHandlerProps): JSX.Element => {
    const navigate = useNavigate();
    const [showBackConfirmation, setShowBackConfirmation] = useState(false);

    useEffect(() => {
        //before unload catches the refresh button
        window.addEventListener('beforeunload', beforeUnloadHandler);
        //keydown catches the f5 refresh
        window.addEventListener('keydown', keydownHandler);
        //popstate catches the back button click
        window.onpopstate = (e) => popstateHandler(e);

        return () => {
            window.removeEventListener('beforeunload', beforeUnloadHandler);
            window.removeEventListener('keydown', keydownHandler);
        };
    }, []);

    const beforeUnloadHandler = (e) => {
        //this will show a browser leaving page popup, this is not customisable and can
        e.preventDefault();
        e.returnValue = '';
    };

    const keydownHandler = useCallback((e) => {
        //here we can display a custom modal to confirm if the page is to refresh or not
        if (e.keyCode === 116) {
            e.preventDefault();
            setShowBackConfirmation(true);
        }
    }, []);

    const popstateHandler = (e) => {
        e.preventDefault();
        console.log('popstate handler');
        window.alert(t('windows_alert'));
        navigate(reloadPath);
    };

    const onReload = () => {
        navigate(reloadPath);
    };

    const onBackCloseConfirmation = (): void => {
        setShowBackConfirmation(false);
    };

    return (
        <ModalDialog
            showDialog={showBackConfirmation}
            title='Confirm Reload'
            primaryButton={{
                text: t('reload'),
                disabled: false,
                onClick: onReload
            }}
            secondaryButton={{
                text: t('cancel'),
                onClick: onBackCloseConfirmation
            }}
            onCloseClick={onBackCloseConfirmation}>
            {t('data_not_saved')}
        </ModalDialog>
    );
};

export default ReloadHandler;
